<bci-card class="banner">
	<img src="assets/images/bci-logo.svg" alt="logo bci" />
	<button bciWkButtonWithIcon [iconName]="'logout'" (click)="onExitSimulator()">Abandonar</button>
</bci-card>
